import clsx from 'clsx';
import { Card } from './Card.jsx';
import { Skeleton } from './Skeleton.jsx';

export function KpiCard({ label, value, sub, icon: Icon, loading = false, className }) {
  return (
    <Card className={clsx('group p-5 transition-all hover:border-border-strong hover:shadow-card', className)}>
      <div className="flex items-start justify-between gap-3">
        <p className="text-xs font-medium text-ink-muted">{label}</p>
        {Icon && (
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-accent-soft text-accent">
            <Icon className="h-4 w-4" strokeWidth={1.75} />
          </span>
        )}
      </div>
      {loading ? (
        <Skeleton className="mt-2 h-8 w-24" />
      ) : (
        <p className="animate-slide-in-up mt-2 text-3xl font-semibold tracking-tight text-ink">{value}</p>
      )}
      {sub && !loading && <p className="mt-1 text-xs text-ink-muted">{sub}</p>}
    </Card>
  );
}
